export default __webpack_public_path__ + "static/media/Montezuma.c2d38bdc.jpg";